'use strict';
import { ApiCommon } from './api-common.js';
import { CommonConsts } from './common.js';

//========================================================================
// 広域変数
//========================================================================
let g_ApiCommon = null;

/**
 * クラス：API単一呼出し
 */
export class ApiSingle{
    constructor(){
        g_ApiCommon = new ApiCommon();
    }

    /**
     * log レベル指定で、laravelにログを出力
     */
    emitServerLogs(logMsg, logLevel = CommonConsts.LEVEL_ERROR)
    {
        let url = g_ApiBasePath + "api/emit-logs";
        let params = {
            'logMsg' : logMsg,
            'logLevel' : logLevel,
        }
        return g_ApiCommon.apiPost(url, params);
    }

    /**
     * 自分自身の学校を取得する
     */
    getSchoolOwn(year = 0)
    {
        let url = g_ApiBasePath + "api/schools/own";
        let params = null;
        if(0 < year) {
            params = {
                "year" : year,
            }
        }
        return g_ApiCommon.apiGet(url, params);
    }

    /**
     * 学校の新規ユーザー作成URLを取得する
     */
    getNewUserUrl()
    {
        let url = g_ApiBasePath + "api/schools/new-url";
        return g_ApiCommon.apiGet(url);
    }

    /**
     * 学期制設定リストを取得する
     */
    getTermKinds(school_id = 0, year = 0)
    {
        let url = g_ApiBasePath + "api/term-kinds";
        let params = null;
        if(0 < school_id) {
            if(null == params) params = {};
            params.school_id = school_id;
        }
        if(0 < year) {
            if(null == params) params = {};
            params.year = year;
        }
        return g_ApiCommon.apiGet(url, params);
    }

    /**
     * 学期制設定を更新する
     */
    updateTermKind(termKind)
    {
        let url = g_ApiBasePath + "api/term-kinds/" + termKind.id;
        return g_ApiCommon.apiPut(url, termKind);
    }

    getUser(userId)
    {
        let url = g_ApiBasePath + "api/users/" + userId;
        return g_ApiCommon.apiGet(url);
    }

    getSchoolUsers(school_id)
    {
        let url = g_ApiBasePath + "api/users/school/" + school_id;
        return g_ApiCommon.apiGet(url);
    }

    createSchoolUsers(school_id, user_count)
    {
        let url = g_ApiBasePath + "api/users/school/create";
        return g_ApiCommon.apiPost(url, {
            school_id: school_id,
            user_count: user_count,
        });
    }
    downloadUsersExcel(filePath, fileName)
    {
        let url = g_ApiBasePath + "api/users/excel/download";
        let params = [];
        params['filePath'] = filePath
        params['fileName'] = fileName
        return g_ApiCommon.formPost(url, params)
    }    

    /**
     * ユーザー更新
     * @param {object} user ユーザー
     * @returns 
     */
    updateUser(user)
    {
        let url = g_ApiBasePath + "api/users/" + user.id;
        return g_ApiCommon.apiPut(url, user);
    }

    /**
     * ユーザー削除
     * @param {object} user ユーザー
     * @returns 
     */
    deleteUser(userId)
    {
        let url = g_ApiBasePath + "api/users/" + userId;
        return g_ApiCommon.apiDelete(url);
    }

    getSchool(schoolId)
    {
        let url = g_ApiBasePath + "api/schools/" + schoolId;
        return g_ApiCommon.apiGet(url);
    }

    /**
     * ユーザー更新
     * @param {object} user ユーザー
     * @returns 
     */
    updateSchool(school)
    {
        let url = g_ApiBasePath + "api/schools/" + school.id;
        return g_ApiCommon.apiPut(url, school);
    }

    /**
     * 
     * @param {number} userId ユーザーID
     * @param {boolean} byManager 管理ユーザーから:true／一般ユーザー自身:false
     * @returns 更新されたユーザーオブジェクト
     */
    promoteToManager(userId, byManager = true)
    {
        let url = g_ApiBasePath + "api/users/" + userId + "/promotion" + (byManager ? "/manager" : "/own");
        return g_ApiCommon.apiPut(url, null);
    }

    /**
     * クラスリスト取得
     * gradeClass: 学年の管理クラスを取得したい場合は true
     */
    getSchoolClasses(school_id, year, grade = 0, gradeClass = false)
    {
        let url = g_ApiBasePath + "api/school-classes";
        let params = {
            "school_id" : school_id,
            "year" : year,
        }
        if(0 < grade) {
            params.grade = grade;
        }
        if(gradeClass) {
            params.gradeClass = gradeClass ? 1 : 0;
        }
        return g_ApiCommon.apiGet(url, params);
    }

    /**
     * 編集可能クラスリスト取得：自ユーザー用
     * ※withManageAllGrade: （true:全学年用管理クラス含めて取得／false:各学年用管理クラス）
     * ※initStudentCount: （true:学生数を初期化する）
     */
    getEditableSchoolClassesOwn(year, withManageAllGrade = false, initStudentCount = false)
    {
        let url = g_ApiBasePath + "api/school-classes/editable/" + year + "/own";
        let params = {};
        // year はurlパラメータで受け渡すためそれ以外
        params.withManageAllGrade = withManageAllGrade ? 1 : 0;
        params.initStudentCount = initStudentCount ? 1 : 0;
        return g_ApiCommon.apiGet(url, params);
    }

    /**
     * 管理クラス取得
     */
    getManageClassesOwn(year, grade)
    {
        let url = g_ApiBasePath + "api/school-classes/manage/" + year + "/" + grade + "/own";
        return g_ApiCommon.apiGet(url);
    }

    /**
     * クラス取得
     */
    getSchoolClass(schoolClassId)
    {
        let url = g_ApiBasePath + "api/school-classes/" + schoolClassId;
        return g_ApiCommon.apiGet(url);
    }

    /**
     * クラス追加
     */
    addSchoolClass(school_id, year, grade, name, nameFlag = false)
    {
        let url = g_ApiBasePath + "api/school-classes";
        let params = {
            "school_id": school_id, 
            "year": year,
            "grade": grade,
            "name": name,
            "name_flag": nameFlag ? 1 : 0
        };    
        return g_ApiCommon.apiPost(url, params);
    }

    /**
     * クラス更新
     */
    updateSchoolClass(schoolClass)
    {
        let url = g_ApiBasePath + "api/school-classes/" + schoolClass.id;
        return g_ApiCommon.apiPut(url, schoolClass);
    }

    /**
     * クラス削除
     */
    deleteSchoolClass(schoolClassId)
    {
        let url = g_ApiBasePath + "api/school-classes/" + schoolClassId;
        return g_ApiCommon.apiDelete(url);
    }

    /**
     * 新クラス名取得
     */
    getNewName(year, scholl_id, grade)
    {
        let url = g_ApiBasePath + "api/school-classes/new-name/" + year + "/" +  scholl_id + "/" + grade;
        return g_ApiCommon.apiGet(url);
    }

    /**
     * クラス名で取得
     */
    getSchoolClassByName(year, scholl_id, grade, name)
    {
        let url = g_ApiBasePath + "api/school-classes/by-name/" + year + "/" +  scholl_id + "/" + grade + "/" + name;
        return g_ApiCommon.apiGet(url);
    }

    /**
     * 一般ユーザーログイン時、一般ユーザーログインID及びパスワードを取得
     */
    generateIdAndPassword()
    {
        let url = g_ApiBasePath + 'api/users/id-password';
        return g_ApiCommon.apiGet(url);
    }

    /**
     * クラス教科設定取得
     * @param {*} schoolClassId 
     * @param {*} withSubjectMasters 
     * @param {*} initTestSettings      * 
     */
    getClassSubjectConfigs(schoolClassId, withSubjectMasters = false, initTestSettings = false)
    {
        let url = g_ApiBasePath + 'api/subject-configs';
        let params = {};
        params.school_class_id = schoolClassId;
        params.subject_master = withSubjectMasters ? 1 : 0;
        params.init_test_settings = initTestSettings ? 1 : 0;
        return g_ApiCommon.apiGet(url, params);
    }

    /**
     * クラス教科設定保存
     * @param {*} schoolClassId 
     * @param {*} subjectConfigs 
     */
    saveClassSubjectConfigs(schoolClassId, subjectConfigs)
    {
        let url = g_ApiBasePath + 'api/subject-configs/save';
        let params = {
            'school_class_id' : schoolClassId,
            'subject_configs' : subjectConfigs,
        }
        return g_ApiCommon.apiPost(url, params);
    }

    /**
     * クラス単元保存
     * @param {*} schoolClassId 
     * @param {*} chapters 
     * @param {*} deleteChapterIds 
     */
    saveClassChapters(schoolClassId, chapters, deleteChapterIds)
    {
        let url = g_ApiBasePath + 'api/chapters/save';
        let params = {
            'school_class_id' : schoolClassId,
            'chapters' : chapters,
            'delete_chapter_ids' : deleteChapterIds,
        }
        return g_ApiCommon.apiPost(url, params);
    }

    /**
     * 指定教科書会社・学期の単元を自作単元として追加
     * @param {*} schoolClassId 
     * @param {*} subjectId 
     * @param {*} publisherId 
     * @param {*} terms 
     */
    addTermTestChapters(schoolClassId, subjectId, publisherId, terms)
    {
        let url = g_ApiBasePath + 'api/chapters/add-term-tests';
        let params = {
            'school_class_id' : schoolClassId,
            'subject_id' : subjectId,
            'publisher_id' : publisherId,
            'terms' : terms,
        }
        return g_ApiCommon.apiPost(url, params);
    }

    /**
     * 指定クラス教科の単元採点データを取得
     * @param {*} schoolClassId 
     * @param {*} subjectId 
     * @param {*} chapterIds // 単元を指定した場合は、指定単元のみ取得
     * @param {*} skipInitMarks // trueの場合は初期化をスキップする
    */
    getClassSubjectChaptersMarks(schoolClassId, subjectId = null, chapterIds = [], skipInitMarks = false)
    {
        let url = g_ApiBasePath + "api/chapter-marks/class-subject-chapters";
        let params = {
            "school_class_id" : schoolClassId,
            "subject_id" : subjectId,
            "chapter_ids" : chapterIds,
        } 
        params.skip_init_marks = skipInitMarks ? 1 : 0;
        return g_ApiCommon.apiGet(url, params);
    }

    /**
     * ぶんけいテストに初期化
     * @param {*} schoolClassId 
     * @param {*} subjectId 
     * @param {*} masterTestNo 
     * @returns 
     */
    initTestToBunkei(schoolClassId, subjectId, masterTestNo)
    {
        let url = g_ApiBasePath + 'api/test/init/bunkei';
        let params = {
            'school_class_id' : schoolClassId,
            'subject_id' : subjectId,
            'master_test_no' : masterTestNo,
        }
        return g_ApiCommon.apiPost(url, params);
    }

    /**
     * 自作テストに初期化
     * @param {*} schoolClassId 
     * @param {*} subjectId 
     * @param {*} publisherId 
     * @param {*} termKind 
     * @param {*} isReferenceBunkeiTest 自作にする際にぶんけいテストを参照するかどうか
     * @param {*} setPublisherIdToNull ぶんけいテストを参照して自作とする場合に、教科設定の教科書はnullに設定する場合あり（単元編集画面の「文溪堂のテストを参照する」で自作として参照した場合）            *        
     * @returns 
     */
    initTestToCustom(schoolClassId, subjectId, publisherId, termKind, isReferenceBunkeiTest = false, setPublisherIdToNull = false)
    {
        let url = g_ApiBasePath + 'api/test/init/custom';
        let params = {
            'school_class_id' : schoolClassId,
            'subject_id' : subjectId,
            'publisher_id' : publisherId,
            'term_kind' : termKind,
        }
        params.is_ref_bunkei = isReferenceBunkeiTest ? 1 : 0;
        params.set_publisher_id_to_null = setPublisherIdToNull ? 1 : 0;
        return g_ApiCommon.apiPost(url, params);
    }

    /**
     * 未使用にする
     * @param {*} schoolClassId 
     * @param {*} subjectId 
     * @returns 
     */
    initTestNoUse(schoolClassId, subjectId)
    {
        let url = g_ApiBasePath + 'api/test/init/nouse';
        let params = {
            'school_class_id' : schoolClassId,
            'subject_id' : subjectId,
        }
        return g_ApiCommon.apiPost(url, params);
    }

    /**
     * 学校の全クラスのテスト設定を初期化する
     * @param {*} schoolId 
     */
    resetSchoolAllClassTestConfig(schoolId)
    {
        let url = g_ApiBasePath + 'api/reset/school/test-config';
        let params = {
            'school_id' : schoolId,
        }
        return g_ApiCommon.apiPost(url, params);
    }

    /**
     * 指定クラス・教科のテスト設定を標準に戻す
     * @param {*} schoolClassId 
     * @param {*} subjectId 
     */
    resetTestToDefault(schoolClassId, subjectId)
    {
        let url = g_ApiBasePath + 'api/test/reset/default';
        let params = {
            'school_class_id' : schoolClassId,
            'subject_id' : subjectId,
        }
        return g_ApiCommon.apiPost(url, params);
    }

    /**
     * 学校のバックアップファイル一覧を取得する
     * @param {number} school_id 学校ID
     * @returns [
     *   backup_file_name: バックアップファイル名称（拡張子を除去したファイルベース名）
     *   download_url: 当該ファイルをダウンロードするためのURL（downloadBackupFile コール同等）
     * ]
     */
    getBackupFiles(school_id)
    {
        let url = g_ApiBasePath + "api/backup/school/files";
        let params = {
            "school_id" : school_id,
        } 
        return g_ApiCommon.apiGet(url, params);
    }

    /**
     * 指定した名称のバックアップファイルをダウンロードする
     * @param {*} backup_file_name バックアップファイル名
     */
    downloadBackupFile(school_id, backup_file_name)
    {
        let url = g_ApiBasePath + "api/backup/school/download"
        let params = []
        params['school_id'] = school_id
        params['backup_file_name'] = backup_file_name
        url = g_ApiCommon.addUrlParams(url, params)
        window.location = url
    }

    /**
     * 学校のバックアップファイルをアップロードする
     * @param {number} school_id アップロード先の学校ID
     * @param {object} file バックアップファイル（zip）
     */
    uploadBackupFile(school_id, file)
    {
        return new Promise((resolve, reject) => {
            let url = g_ApiBasePath + "api/backup/school/upload"
            //console.log(url)

            const fd = new FormData();
            fd.append('file', file)
            fd.append('school_id', school_id)

            $.ajax({
                url: url,
                type:'post',
                data: fd,
                processData: false,
                async : true,
                cache : false,
                contentType: false,
            }).done(function (data) {
                resolve(data);
            }).fail(function() {
                reject();
            })
        })
    }

    /**
     * バックアップファイルからクラスを復元する
     * @param {number} school_id 学校ID
     * @param {string} backup_file_name バックアップファイル名
     * @param {number} school_class_id クラスID
     */
    restoreClass(school_id, backup_file_name, school_class_id)
    {
        let url = g_ApiBasePath + "api/backup/school/restore-class"
        let params = {
            'school_id' : school_id,
            'backup_file_name' : backup_file_name,
            'school_class_id' : school_class_id,
        }
        return g_ApiCommon.apiPost(url, params);
    }
    /**
     * 追加バックアップ
     * @param {number} school_id 学校ID
     */
    addSchoolBackup(school_id)
    {
        let url = g_ApiBasePath + "api/backup/school/add"
        let params = {
            'school_id' : school_id,
        }
        return g_ApiCommon.apiPost(url, params);
    }

    /**
     * クラス設定データのダウンロード
     * @param {number} schoolClassId 
     * @returns なし（そのままダウンロード）
     */
    downloadClassConfig(schoolClassId)
    {
        let url = g_ApiBasePath + "api/exports/class-config/download";
        let params = [];
        params['school_class_id'] = schoolClassId;
        url = g_ApiCommon.addUrlParams(url, params)
        window.location = url;
    }

    /**
     * クラス設定のインポート
     * @param {number} schoolClassId 取り込み先クラス
     * @param {object} file 取り込みファイル（fromClassIdと排他）
     * @param {number} fromClassId 取り込み元クラス（fileと排他）
     * @param {boolean} importTestSettings テスト設定（true/false）
     * @param {boolean} importVpCriterias 評価基準の設定（true/false）
     * @param {boolean} importSrViewpoints 学習の記録観点設定（true/false）
     * @param {boolean} selectedTerms 選択した学期
     * @param {boolean} selectedSubjectIds 選択した教科
     * @param {number} importType 
     * file と fromClassId が同時に指定された場合の動作は未定義。
     * @returns 処理結果
     */
    importClassConfig(
        schoolClassId,
        file,
        fromClassId,
        importTestSettings,
        importVpCriterias,
        importSrViewpoints,
        selectedTerms,
        selectedSubjectIds,
        importType
        )
    {
        return new Promise((resolve, reject) => {
            //console.log('loadClassConfig:' + schoolClassId + ":" + file);
            let url = "";
            if(2 == importType) {
                // てんまる設定ファイルからの取り込み
                url = g_ApiBasePath + "api/exports/tenmaru-config/import";
            }
            else {
                // それ以外
                url = g_ApiBasePath + "api/exports/class-config/import";
            }

            const fd = new FormData();
            if(null != file) {
                fd.append('file', file);
            }
            if(null != fromClassId) {
                fd.append('from_class_id', fromClassId);
            }
            fd.append('school_class_id', schoolClassId);
            fd.append('import_test_settings', importTestSettings ? 1 : 0);
            fd.append('import_viewpoint_criterias', importVpCriterias ? 1 : 0);
            fd.append('import_sr_viewpoints', importSrViewpoints ? 1 : 0);            
            fd.append('selected_subject_ids', JSON.stringify(selectedSubjectIds));
            fd.append('selected_terms', JSON.stringify(selectedTerms));
            fd.append('importType', importType);
        
            $.ajax({
                url: url,
                type:'post',
                data: fd,
                processData: false,
                async : true,
                cache : false,
                contentType: false,
            }).done(function (data) {
                resolve(data);
            }).fail(function() {
                reject();
            });
        })
    }

    /**
     * クラス設定データのロード
     * @param {number} schoolClassId 取り込み先クラス
     * @param {object} file 取り込みファイル
     * @returns クラス設定データ
     */
    loadClassConfig(schoolClassId, file)
    {
        return new Promise((resolve, reject) => {
            //console.log('loadClassConfig:' + schoolClassId + ":" + file);
            let url = g_ApiBasePath + "api/exports/class-config/load";

            const fd = new FormData();
            fd.append('file', file);
            fd.append('school_class_id', schoolClassId);
        
            $.ajax({
                url: url,
                type:'post',
                data: fd,
                processData: false,
                async : true,
                cache : false,
                contentType: false,
            }).done(function (data) {
                resolve(data);
            }).fail(function() {
                reject();
            });
        })
    }

    /**
     * てんまるクラス設定データのロード
     * @param {number} schoolClassId 取り込み先クラス
     * @param {object} file 取り込みファイル
     * @returns てんまるクラス設定データ
     */
    loadTenmaruConfig(schoolClassId, file)
    {
        return new Promise((resolve, reject) => {
            //console.log('loadTenmaruConfig:' + schoolClassId + ":" + file);
            let url = g_ApiBasePath + "api/exports/tenmaru-config/load";

            const fd = new FormData();
            fd.append('file', file);
            fd.append('school_class_id', schoolClassId);
        
            $.ajax({
                url: url,
                type:'post',
                data: fd,
                processData: false,
                async : true,
                cache : false,
                contentType: false,
            }).done(function (data) {
                resolve(data);
            }).fail(function() {
                reject();
            });
        })
    }


    /**
     * 全クラスにテスト設定を反映
     * テスト設定 ~
     * ・subject_configs
     * ・chapters
     * ・viewpoint_comments
     * ・sr_comments
     */
    reflectTestSettingsToAllClasses(schoolClassId)
    {
        let url = g_ApiBasePath + "api/test-settings/reflect/all";
        return g_ApiCommon.apiPost(url, {
            'school_class_id': schoolClassId,
        });
    }

    /**
     * 同一学年の全クラスに評価基準の設定を反映
     */
    reflectVpCriteriasToAllClasses(schoolClassId)
    {
        let url = g_ApiBasePath + "api/vp-criterias/reflect/all";
        return g_ApiCommon.apiPost(url, {
            'school_class_id': schoolClassId,
        });
    }

    /**
     * 同一学年の全クラスに学習の記録の観点設定を反映
     */
    reflectSrViewpointsToAllClasses(schoolClassId)
    {
        let url = g_ApiBasePath + "api/sr-viewpoints/reflect/all";
        return g_ApiCommon.apiPost(url, {
            'school_class_id': schoolClassId,
        });
    }

    /**
     * 全クラスの観点設定を一括設定
     */
    batchSettingsForSrViewpoints(schoolClassId, term, subjectId)
    {
        let url = g_ApiBasePath + "api/sr-viewpoints/batch-settings";
        return g_ApiCommon.apiPost(url, {
            'school_class_id': schoolClassId,
            'term': term,
            'subject_id': subjectId,
        });
    }

    /**
     * 単元編集画面pdf作成
     * @param {*} schoolClassId 
     * @param {*} pdfParams 
     */
    makeChaptersTablePdf(schoolClassId, pdfParams)
    {
        let url = g_ApiBasePath + "api/chapter-setting/pdf/make";
        let params = {
            'school_class_id' : schoolClassId,
            'pdf_params' : pdfParams,
        };
        return g_ApiCommon.apiPost(url, params);
    }

    /**
     * 単元編集画面pdfダウンロード
     * @param {*} schoolClassId 
     * @param {*} pdfFilePath 
     */
    downloadChaptersTablePdf(schoolClassId, pdfFilePath)
    {
        let url = g_ApiBasePath + "api/chapter-setting/pdf/download";
        let params = {
            'school_class_id' : schoolClassId,
            'pdf_file_path' : pdfFilePath,
        };
        g_ApiCommon.formPost(url, params);
    }

    /**
     * 評価基準画面pdf作成
     * @param {*} schoolClassId 
     * @param {*} pdfParams 
     */
    makeVpCriteriaTablePdf(schoolClassId, pdfParams)
    {
        let url = g_ApiBasePath + "api/vp-criteria/pdf/make";
        let params = {
            'school_class_id' : schoolClassId,
            'pdf_params' : pdfParams,
        };
        return g_ApiCommon.apiPost(url, params);
    }

    /**
     * 評価基準画面pdfダウンロード
     * @param {*} schoolClassId 
     * @param {*} pdfFilePath 
     */
    downloadVpCriteriaTablePdf(schoolClassId, pdfFilePath)
    {
        let url = g_ApiBasePath + "api/vp-criteria/pdf/download";
        let params = {
            'school_class_id' : schoolClassId,
            'pdf_file_path' : pdfFilePath,
        };
        g_ApiCommon.formPost(url, params);
    }

    /**
     * 観点別集計画面pdf作成
     * @param {*} schoolClassId 
     * @param {*} pdfParams 
     */
    makePerViewpointSummaryPdf(schoolClassId, pdfParams)
    {
        let url = g_ApiBasePath + "api/perviewpoint-summary/pdf/make";
        let params = {
            'school_class_id' : schoolClassId,
            'pdf_params' : pdfParams,
        };
        return g_ApiCommon.apiPost(url, params);
    }

    /**
     * 観点別集計画面pdfダウンロード
     * @param {*} schoolClassId 
     * @param {*} pdfFilePath 
     */
    downloadPerViewpointSUmmaryPdf(schoolClassId, pdfFilePath)
    {
        let url = g_ApiBasePath + "api/perviewpoint-summary/pdf/download";
        let params = {
            'school_class_id' : schoolClassId,
            'pdf_file_path' : pdfFilePath,
        };
        g_ApiCommon.formPost(url, params);
    }

    /**
     * 単元別集計画面pdf作成
     * @param {*} schoolClassId 
     * @param {*} pdfParams 
     */
    makePerChapterSummaryPdf(schoolClassId, pdfParams)
    {
        let url = g_ApiBasePath + "api/perchapter-summary/pdf/make";
        let params = {
            'school_class_id' : schoolClassId,
            'pdf_params' : pdfParams,
        };
        return g_ApiCommon.apiPost(url, params);
    }

    /**
     * 単元別集計画面pdfダウンロード
     * @param {*} schoolClassId 
     * @param {*} pdfFilePath 
     */
    downloadPerChapterSummaryPdf(schoolClassId, pdfFilePath)
    {
        let url = g_ApiBasePath + "api/perchapter-summary/pdf/download";
        let params = {
            'school_class_id' : schoolClassId,
            'pdf_file_path' : pdfFilePath,
        };
        g_ApiCommon.formPost(url, params);
    }

    /**
     * 観点別診断票pdf作成
     * @param {*} schoolClassId 
     * @param {*} pdfParams 
     */
    makePerViewpointCartePdf(schoolClassId, pdfParams)
    {
        let url = g_ApiBasePath + "api/perviewpoint-carte/pdf/make";
        let params = {
            'school_class_id' : schoolClassId,
            'pdf_params' : pdfParams,
        };
        return g_ApiCommon.apiPost(url, params);
    }

    /**
     * 観点別診断票pdfダウンロード
     * @param {*} schoolClassId 
     * @param {*} pdfFilePath 
     */
    downloadPerViewpointCartePdf(schoolClassId, pdfFilePath)
    {
        let url = g_ApiBasePath + "api/perviewpoint-carte/pdf/download";
        let params = {
            'school_class_id' : schoolClassId,
            'pdf_file_path' : pdfFilePath,
        };
        g_ApiCommon.formPost(url, params);
    }

    /**
     * 単元別診断票pdf作成
     * @param {*} schoolClassId 
     * @param {*} pdfParams 
     */
    makePerChapterCartePdf(schoolClassId, pdfParams)
    {
        let url = g_ApiBasePath + "api/perchapter-carte/pdf/make";
        let params = {
            'school_class_id' : schoolClassId,
            'pdf_params' : pdfParams,
        };
        return g_ApiCommon.apiPost(url, params);
    }

    /**
     * 単元別診断票pdfダウンロード
     * @param {*} schoolClassId 
     * @param {*} pdfFilePath 
     */
    downloadPerChapterCartePdf(schoolClassId, pdfFilePath)
    {
        let url = g_ApiBasePath + "api/perchapter-carte/pdf/download";
        let params = {
            'school_class_id' : schoolClassId,
            'pdf_file_path' : pdfFilePath,
        };
        g_ApiCommon.formPost(url, params);
    }

    /**
     * 学習の記録pdf作成
     * @param {*} schoolClassId 
     * @param {*} pdfParams 
     */
    makeStudyRegistryPdf(schoolClassId, pdfParams)
    {
        let url = g_ApiBasePath + "api/study-registry/pdf/make";
        let params = {
            'school_class_id' : schoolClassId,
            'pdf_params' : pdfParams,
        };
        return g_ApiCommon.apiPost(url, params);
    }

    /**
     * 学習の記録pdfダウンロード
     * @param {*} schoolClassId 
     * @param {*} pdfFilePath 
     */
    downloadStudyRegistryPdf(schoolClassId, pdfFilePath)
    {
        let url = g_ApiBasePath + "api/study-registry/pdf/download";
        let params = {
            'school_class_id' : schoolClassId,
            'pdf_file_path' : pdfFilePath,
        };
        g_ApiCommon.formPost(url, params);
    }

    /**
     * 所見pdf作成
     * @param {*} schoolClassId 
     * @param {*} pdfParams 
     */
    makeFindingsTablePdf(schoolClassId, pdfParams)
    {
        let url = g_ApiBasePath + "api/findings-table/pdf/make";
        let params = {
            'school_class_id' : schoolClassId,
            'pdf_params' : pdfParams,
        };
        return g_ApiCommon.apiPost(url, params);
    }

    /**
     * 所見pdfダウンロード
     * @param {*} schoolClassId 
     * @param {*} pdfFilePath 
     */
    downloadFindingsTablePdf(schoolClassId, pdfFilePath)
    {
        let url = g_ApiBasePath + "api/findings-table/pdf/download";
        let params = {
            'school_class_id' : schoolClassId,
            'pdf_file_path' : pdfFilePath,
        };
        g_ApiCommon.formPost(url, params);
    }

    /**
     * クラス設定の保存：（RESTのPUTメソッドを呼び出す）
     * @param {*} classConfig 保存するクラス設定インスタンス
     */
    saveClassConfig(classConfig, isUpdateConfigMarkCommon = false)
    {
        let url = g_ApiBasePath + "api/class-configs/" + classConfig.id;
        let params = {
            'class_config' : classConfig,
            'is_update_config_mark_common' : isUpdateConfigMarkCommon ? 1 : 0,
        }
        return g_ApiCommon.apiPut(url, params);
    }

    /**
     * 学習の記録観点設定デフォルト取得
     * ※学習の記録観点設定モーダルでの使用を想定
     * 【返却データ】
     * ・クラスの全教科デフォルト設定：指導要録の観点で設定
     * ・クラスの全教科デフォルト設定：てんまるの単元で設定
     * ・全教科の要録観点配列
     * ・全教科の単元配列
     * @param {*} schoolClassId 
     */
    getSRViewpointConfigsDefaults(schoolClassId)
    {
        let url = g_ApiBasePath + "api/class-configs/sr-viewpoint/defaults";
        return g_ApiCommon.apiGet(url, {
            'school_class_id' : schoolClassId,
        })
    }

    /**
     * 集計表入力テーブルEXCEL作成
     * @param {*} schoolClassId 
     * @param {*} excelParams 
     */
    makeInputSummaryExcel(schoolClassId, excelParams)
    {
        let url = g_ApiBasePath + "api/input-summary/make/excel";
        let params = {
            'school_class_id' : schoolClassId,
            'excel_params' : excelParams,
        };
        return g_ApiCommon.apiPost(url, params);
    }

    /**
     * 集計表入力テーブルEXCEL出力
     * @param {*} filePath 
     * @param {*} fileName 
     */
    exportInputSummaryExcel(filePath, fileName)
    {
        let url = g_ApiBasePath + "api/input-summary/export/excel";
        let params = {
            'file_path' : filePath,
            'file_name' : fileName,
        };
        g_ApiCommon.formPost(url, params);
    }

    /**
     * 観点別集計画面EXCEL作成
     * @param {*} schoolClassId 
     * @param {*} excelParams 
     */
    makePerViewpointSummaryExcel(schoolClassId, excelParams)
    {
        let url = g_ApiBasePath + "api/perviewpoint-summary/make/excel";
        let params = {
            'school_class_id' : schoolClassId,
            'excel_params' : excelParams,
        };
        return g_ApiCommon.apiPost(url, params);
    }

    /**
     * 観点別集計画面EXCEL出力
     * @param {*} filePath 
     * @param {*} fileName 
     */
    exportPerViewpointSummaryExcel(filePath, fileName)
    {
        let url = g_ApiBasePath + "api/perviewpoint-summary/export/excel";
        let params = {
            'file_path' : filePath,
            'file_name' : fileName,
        };
        g_ApiCommon.formPost(url, params);
    }

    /**
     * 単元別集計画面EXCEL作成
     * @param {*} schoolClassId 
     * @param {*} excelParams 
     */
    makePerChapterSummaryExcel(schoolClassId, excelParams)
    {
        let url = g_ApiBasePath + "api/perchapter-summary/make/excel";
        let params = {
            'school_class_id' : schoolClassId,
            'excel_params' : excelParams,
        };
        return g_ApiCommon.apiPost(url, params);
    }

    /**
     * 単元別集計画面EXCEL出力
     * @param {*} filePath 
     * @param {*} fileName 
     */
    exportPerChapterSummaryExcel(filePath, fileName)
    {
        let url = g_ApiBasePath + "api/perchapter-summary/export/excel";
        let params = {
            'file_path' : filePath,
            'file_name' : fileName,
        };
        g_ApiCommon.formPost(url, params);
    }

    /**
     * 集計表入力テーブルEXCEL解析
     * @param {*} schoolClassId
     * @param {*} file
     */
    analyzeInputSummaryExcel(schoolClassId, file)
    {
       return new Promise((resolve, reject) => {
            let url = g_ApiBasePath + "api/input-summary/analyze/excel";
            //console.log(url)

            const fd = new FormData();
            fd.append('file', file)
            fd.append('school_class_id', schoolClassId)

            $.ajax({
                url: url,
                type:'post',
                data: fd,
                processData: false,
                async : true,
                cache : false,
                contentType: false,
            }).done(function (data) {
                resolve(data);
            }).fail(function() {
                reject();
            })
        })
    }

    /**
     * 集計表入力：クリップ採点CSV解析
     * @param {*} schoolClassId
     * @param {*} file
     */    
    analyzeClipScoringCsv(schoolClassId, subjectId, term, file)
    {
        return new Promise((resolve, reject) => {
            let url = g_ApiBasePath + "api/input-summary/analyze/csv/clip-scoring";
            //console.log(url)

            const fd = new FormData();
            fd.append('file', file)
            fd.append('school_class_id', schoolClassId)
            fd.append('subject_id', subjectId)
            fd.append('term', term)

            $.ajax({
                url: url,
                type:'post',
                data: fd,
                processData: false,
                async : true,
                cache : false,
                contentType: false,
            }).done(function (data) {
                resolve(data);
            }).fail(function() {
                reject();
            })
        })
    }

    /**
     * 集計表入力テーブルEXCEL解析データを単元指定で取り込む
     * @param {*} schoolClassId 
     * @param {*} selectChapterIds 
     * @param {*} data 
     * @returns 
     */
    importInputSummaryExcelData(schoolClassId, selectChapterIds, data)
    {
        let url = g_ApiBasePath + "api/input-summary/import/excel/data";
        let params = {
            'school_class_id' : schoolClassId,
            'select_chapter_ids' : selectChapterIds,
            'data' : data,
        };
        return g_ApiCommon.apiPost(url, params);
    }

    /**
     * 観点別診断票EXCEL作成
     * @param {*} schoolClassId 
     * @param {*} excelParams 
     */
    makePerViewpointCarteExcel(schoolClassId, excelParams)
    {
        let url = g_ApiBasePath + "api/perviewpoint-carte/make/excel";
        let params = {
            'school_class_id' : schoolClassId,
            'excel_params' : excelParams,
        };
        return g_ApiCommon.apiPost(url, params);
    }

    /**
     * 観点別診断票EXCEL出力
     * @param {*} filePath 
     * @param {*} fileName 
     */
    exportPerViewpointCarteExcel(filePath, fileName)
    {
        let url = g_ApiBasePath + "api/perviewpoint-carte/export/excel";
        let params = {
            'file_path' : filePath,
            'file_name' : fileName,
        };
        g_ApiCommon.formPost(url, params);
    }

    /**
     * 単元別診断票EXCEL作成
     * @param {*} schoolClassId 
     * @param {*} excelParams 
     */
    makePerChapterCarteExcel(schoolClassId, excelParams)
    {
        let url = g_ApiBasePath + "api/perchapter-carte/make/excel";
        let params = {
            'school_class_id' : schoolClassId,
            'excel_params' : excelParams,
        };
        return g_ApiCommon.apiPost(url, params);
    }

    /**
     * 単元別診断票EXCEL出力
     * @param {*} filePath 
     * @param {*} fileName 
     */
    exportPerChapterCarteExcel(filePath, fileName)
    {
        let url = g_ApiBasePath + "api/perchapter-carte/export/excel";
        let params = {
            'file_path' : filePath,
            'file_name' : fileName,
        };
        g_ApiCommon.formPost(url, params);
    }

    /**
     * 児童名簿EXCEL作成
     * @param {*} schoolClassId 
     * @param {*} excelParams 
     */
    makeStudentsExcel(schoolClassId, excelParams)
    {
        let url = g_ApiBasePath + "api/students/make/excel";
        let params = {
            'school_class_id' : schoolClassId,
            'excel_params' : excelParams,
        };
        return g_ApiCommon.apiPost(url, params);
    }

    /**
     * 児童名簿EXCEL出力
     * @param {*} filePath 
     * @param {*} fileName 
     */
    exportStudentsExcel(filePath, fileName)
    {
        let url = g_ApiBasePath + "api/students/export/excel";
        let params = {
            'file_path' : filePath,
            'file_name' : fileName,
        };
        g_ApiCommon.formPost(url, params);
    }

    /**
     * 学習の記録EXCEL作成
     * @param {*} schoolClassId 
     * @param {*} excelParams 
     */
    makeStudyRegistryExcel(schoolClassId, excelParams)
    {
        let url = g_ApiBasePath + "api/study-registry/make/excel";
        let params = {
            'school_class_id' : schoolClassId,
            'excel_params' : excelParams,
        };
        return g_ApiCommon.apiPost(url, params);
    }

    /**
     * 学習の記録EXCEL出力
     * @param {*} filePath 
     * @param {*} fileName 
     */
    exportStudyRegistryExcel(filePath, fileName)
    {
        let url = g_ApiBasePath + "api/study-registry/export/excel";
        let params = {
            'file_path' : filePath,
            'file_name' : fileName,
        };
        g_ApiCommon.formPost(url, params);
    }

    /**
     * 所見EXCEL作成
     * @param {*} schoolClassId 
     * @param {*} excelParams 
     */
    makeFindingsTableExcel(schoolClassId, excelParams)
    {
        let url = g_ApiBasePath + "api/findings-table/make/excel";
        let params = {
            'school_class_id' : schoolClassId,
            'excel_params' : excelParams,
        };
        return g_ApiCommon.apiPost(url, params);
    }    

    /**
     * 所見EXCEL出力
     * @param {*} filePath 
     * @param {*} fileName 
     */
    exportFindingsTableExcel(filePath, fileName)
    {
        let url = g_ApiBasePath + "api/findings-table/export/excel";
        let params = {
            'file_path' : filePath,
            'file_name' : fileName,
        };
        g_ApiCommon.formPost(url, params);
    }

    /**
     * ユーザー通知を削除
     * @param {*} userNoticeId 削除対象通知ID
     */
    deleteUserNotice(userNoticeId)
    {
        let url = g_ApiBasePath + "api/user-notices/" + userNoticeId;
        return g_ApiCommon.apiDelete(url);
    }

    /**
     * システム環境設定値保存
     * @param {*} $key キー
     * @param {*} $value 値
     */
    saveSystemConfigValue(key, value)
    {
        let url = g_ApiBasePath + "api/admin/configs/system/" + key;
        return g_ApiCommon.apiPost(url, {
            value: value
        });
    }

    /**
     * ssoで登録した一般ユーザーの管理者への昇格
     */
    ssoTypePublicUserPromotion()
    {
        let url = g_ApiBasePath + "api/sso-type-user/promote";
        return g_ApiCommon.apiPost(url, null);        
    }

    /**
     * 評定段階数変換
     * @param {*} schoolClassId 
     * @param {*} changeRatingStepsInfo 段階数変更情報
     */
    convertRatingSteps(schoolClassId, changeRatingStepsInfo)
    {
        let url = g_ApiBasePath + "api/study-registry/rating-steps/convert";
        return g_ApiCommon.apiPost(url, {
            school_class_id: schoolClassId,
            change_rating_steps_info: changeRatingStepsInfo,
        })
    }

    /**
     * Te-Comp@ss用XML作成
     * @param {*} schoolClassId 
     * @param {*} term 
     * @param {*} items 対象項目パラメタオブジェクト
     */
    makeTeCompassXml(schoolClassId, term, items, loginInfo)
    {
        let url = g_ApiBasePath + "api/study-registry/make/xml/te-compass";
        return g_ApiCommon.apiPost(url, {
            school_class_id: schoolClassId,
            term: term,
            items: items,
            login_info: loginInfo,
        })
    }

    exportTeCompassXml(filePath, fileName)
    {
        let url = g_ApiBasePath + "api/study-registry/export/xml/te-compass";
        let params = {
            'file_path' : filePath,
            'file_name' : fileName,
        };
        g_ApiCommon.formPost(url, params);
    }

    /**
     * クラスの自作文例を取得する
     * @param {*} schoolClassId クラスID
     */
    getCustomExamples(schoolClassId)
    {
        let url = g_ApiBasePath + "api/custom-examples";
        return g_ApiCommon.apiGet(url, {
            'school_class_id' : schoolClassId
        })
    }

    /**
     * 自作文例を保存する
     * ※編集済レコードは updated_at を null にして呼び出すこと
     * ※新規レコードは created_at を null にして呼び出すこと
     * ※↑の条件を満たさないレコードは保存しない
     * @param {*} schoolClassId クラスID
     * @param {*} customExamples 
     */
    saveCustomExamples(schoolClassId, customExamples)
    {
        let url = g_ApiBasePath + "api/custom-examples/save";
        return g_ApiCommon.apiPost(url, {
            'school_class_id' : schoolClassId,
            'custom_examples' : customExamples,
        })
    }

    /**
     * 自作文例EXCELを作成する
     * @param {*} schoolClassId クラスID
     * @param {*} customExamples 自作文例配列
     * @returns 処理結果とEXCELファイル情報
     */
    makeCustomExamplesExcel(schoolClassId, customExamples)
    {
        let url = g_ApiBasePath + "api/custom-examples/make/excel";
        return g_ApiCommon.apiPost(url, {
            'school_class_id' : schoolClassId,
            'custom_examples' : customExamples,
        })
    }

    /**
     * 自作文例EXCELを書き出す
     * @param {*} filePath EXCELファイルパス
     * @param {*} fileName EXCELファイル名
     */
    exportCustomExamplesExcel(filePath, fileName)
    {
        let url = g_ApiBasePath + "api/custom-examples/export/excel";
        let params = {
            'file_path' : filePath,
            'file_name' : fileName,
        };
        g_ApiCommon.formPost(url, params);
    }

    /**
     * 自作文例EXCELファイルを取り込む
     * @param {*} schoolClassId クラスID
     * @param {*} file EXCELファイル
     * @returns 処理結果
     */
    importCustomExamplesExcel(schoolClassId, file)
    {
        return new Promise((resolve, reject) => {
            let url = g_ApiBasePath + "api/custom-examples/import/excel";
            //console.log(url)

            const fd = new FormData();
            fd.append('file', file)
            fd.append('school_class_id', schoolClassId)

            $.ajax({
                url: url,
                type:'post',
                data: fd,
                processData: false,
                async : true,
                cache : false,
                contentType: false,
            }).done(function (data) {
                resolve(data);
            }).fail(function() {
                reject();
            })
        })       
    }

    /**
     * 運用年度を翌年度に変更する
     * ※安全のため targetYear に、目標とする年度を入れる
     */
    changeToNextYear(schoolId, targetYear)
    {
        let url = g_ApiBasePath + 'api/schools/' + schoolId + '/change-to-next-year'
        return g_ApiCommon.apiPost(url, {
            'target_year' : targetYear,
        })
    }

    /**
     * 運用年度を前年度に変更する
     * ※安全のため targetYear に、目標とする年度を入れる
     */
    changeToPrevYear(schoolId, targetYear)
    {
        let url = g_ApiBasePath + 'api/schools/' + schoolId + '/change-to-prev-year'
        return g_ApiCommon.apiPost(url, {
            'target_year' : targetYear,
        })
    }

    /**
     * 年次更新後処理
     */
    afterChangeYear()
    {
        let url = g_ApiBasePath + 'next-year-settings/after-change-year'
        window.location.href = url  
    }

    /**
     * 前年度のクラスを取り込む
     * @param {*} schoolId 学校ID
     */
    importSchoolClassesFromPrevYear(schoolId)
    {
        let url = g_ApiBasePath + 'api/school-classes/import/prev-year'
        return g_ApiCommon.apiPost(url, {
            'school_id' : schoolId
        });
    }

    /**
     * 前年度の評価基準設定を取り込む
     * @param {*} schoolId 学校ID
     */
    importVpCriteriasFromPrevYear(schoolId)
    {
        let url = g_ApiBasePath + 'api/vp-criterias/import/prev-year'
        return g_ApiCommon.apiPost(url, {
            'school_id' : schoolId
        });
    }

    /**
     * 前年度の観点設定を取り込む
     * @param {*} schoolId 学校ID
     */
    importSrViewpointsFromPrevYear(schoolId)
    {
        let url = g_ApiBasePath + 'api/sr-viewpoints/import/prev-year'
        return g_ApiCommon.apiPost(url, {
            'school_id' : schoolId
        });
    }

}
